<template>
    <div class="gray-back" style="padding:.2rem 0 1rem 0">
        <van-form
                  @submit="onSubmit"
                  @failed="onFailed"
        >
        <van-cell-group>
            <van-collapse v-model="activeNames" >
                <van-collapse-item v-for="(goods,index) in list"  :name="index">
                    <template #title>
                        <div>{{goods.title}} </div>
                    </template>
                    <template #value>
                        <div v-if="goods.count>0">{{goods.count}}件 </div>
                    </template>
                    <div class="desc">
                        <img class='skuimg' :src="goods.pic_url" />
                        {{goods.desc}}
                        <div class="cf"></div>
                    </div>
                    <van-card
                            v-for="(item ,iindex) in goods.items"
                            :price="item.price+'/'+item.unit"
                            :title="item.title"
                    >
                        <template #tags>
                            小记  ¥{{item.total_price}}
                        </template>
                        <template #num>
                            <van-stepper :min="0" v-model="item.count" theme="round" :name="index+','+iindex" @change="onCountChange"   disable-input input-width="40px" button-size="32px" />
                        </template>
                    </van-card>

                </van-collapse-item>
            </van-collapse>
        </van-cell-group>


        <div class="savebtn">
            <van-button
                    color="linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)"
                    style="width: 3rem"
                    size="normal" round :disabled="saveLoading" :loading="saveLoading" loading-text="提交中..." @click="submit">下一步</van-button>
        </div>
        </van-form>


    </div>
</template>
<style scoped>
    .box {
        /*margin-bottom: 1.5rem;*/
    }



    .savebtn {
        position: fixed;
        bottom: 0;
        padding-bottom: 0.2rem;
        width: 100%;
        z-index: 10;
        display: flex;
        flex: 1;
        flex-direction: row;
        justify-content: space-around;
        background: linear-gradient(180deg,hsla(0,0%,100%,0),#fff);
    }


    .van-tag {
        width: 55px;
        margin-left: 10px;
        text-align: center;
    }
    .between {
        justify-content: space-between;
    }
    .desc{
        color: #666;
    }
    .desc .skuimg{
        width: 100px;
        margin-right: 10px;
        float: left;
    }


</style>
<script>
    import Vue from 'vue';
    import area from "../../../utils/area";
    import validator from "../../../utils/validator";
    import PicUploader from '@/components/picker/PicUploader.vue';

    import {Card,Cell,Field,Area,Form,Divider, CellGroup,RadioGroup,Radio,Icon, Toast, Popup, Picker, Sidebar, SidebarItem, Tag, Stepper ,Switch ,Button} from 'vant';

    Vue.use(Cell).use(CellGroup).use(Form).use(Divider).use(Area).use(RadioGroup).use(Radio).use(Icon).use(Toast).use(Popup).use(Picker).use(Sidebar).use(SidebarItem).use(Tag).use(Stepper).use(Field)
            .use(Switch).use(Button).use(Card);
    export default {
        name: 'ClubApply',
        components: {
            PicUploader,
        },
        data: function () {
            return {
                validator,
                saveLoading:false,
                showArea:false,
                areaList:{},
                areaValue:'',
                submitType:'',
                value:1,
                activeNames:[
                ],
                formData: {
                    id: 0,
                    areas:'',
                    province:'',
                    contactsqq:'',
                    qq:'',
                    city:'',
                    county:'',
//                    changdipic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    changdipic: [],
                    shenbaozip: [],
//                    zhizhaopic: [{"uid":"vc-upload-1587109262602680","url":"https://cheeseman.oss-cn-hangzhou.aliyuncs.com/h5/2020-04-17/1587109262602680.jpg","name":"支付宝.jpg","save_name":"h5/2020-04-17/1587109262602680.jpg"}],
                    zhizhaopic: [],
                },
                list:[]
            }
        },
        filters: {},
        mounted() {
            document.title="开始建设"
            let that = this;
            that.areaList = area;
            that.formData.id = this.$route.query.id;
               if(that.formData.id){
                this.fetch();
               }
        },
        watch: {
            list2:{
                handler:function(val,oldval){
                    let list = JSON.parse(JSON.stringify(this.list))
                    list.map((goods,index) => {
                        goods.count = 0;
                        goods.items.map((item,iindex) =>{
                            goods.count += item.count;
                            item.total_price = item.count * item.price;
                        });
                    });
                    return list;
                },
                deep:true
            },
        },
        destroyed() {
        },
        computed:{
          total_count(){
              let count = 0;
              this.list.map(goods =>{
                  count +=goods.count
              });
              return count;
          }
        },
        methods: {
            onQuestion(){
                console.log('onQuestion')
            },
            onAreaConfirm(values) {
                console.log(values);
                this.formData.area = values[2].code;
                this.formData.province = values[0].name;
                this.formData.city = values[1].name;
                this.formData.county = values[2].name;
                this.showArea = false;
            },
            onSubmit(values){
                console.log('onSubmit-values',values);
                console.log('submitType',this.submitType);

                let that = this;
                console.log(that.formData)
                that.formValidate = true;

                if(this.total_count ==0 ){
                    Toast.fail('请选择器材');
                    return ;
                }

                for (let field in that.formData) {

                }
                that.saveLoading = true;

                that.$api.post('/api/club/jianshestep2save', {
                    id:that.formData.id,
                    list:JSON.stringify(that.list)
                }, (res) => {
                    that.saveLoading = false;
                    rbLink({
                        name:"ClubJiansheStep3",
                        query:{
                            id:res.data.id
                        }
                    },'replace')

                }, (res) => {
                    Toast.fail(res.msg);
                    that.saveLoading = false;
                })
            },
            save(values){
                this.submitType = 'save';
            },
            onFailed(errorInfo){
                console.log('failed', errorInfo);
            },
            submit(values) {
                this.submitType = 'submit';
            },
            onCountChange(value,detail){
                console.log(value,detail);
                let index =detail.name.split(',')[0];
                let iindex =detail.name.split(',')[1];
                this.list[index].items[iindex].total_price = this.list[index].items[iindex].count * this.list[index].items[iindex].price;
                let sub_goods_count = 0;
                this.list[index].items.map(item =>{
                    sub_goods_count += item.count;
                })
                this.list[index].count = sub_goods_count;
            },
            fetch(){
                let that = this;
                that.$api.post('/api/club/jiansheStep2Detail', {
                    id:that.formData.id
                }, (res) => {
                    that.list = res.data.list;

                }, (res) => {
                   Toast.fail(res.msg);
                })
            }

        }
    }
</script>



// WEBPACK FOOTER //
// ClubJiansheStep2.vue?70a01923